import _ from 'lodash/fp';
import GraniteError from 'granite-admin/utils/granite-error';
import useTimeZone from 'granite-admin/utils/useTimeZone';
const {
  country
} = useTimeZone();
class User {
  constructor({
    username,
    first_name,
    last_name,
    email,
    create_date,
    profile_image,
    phone,
    country_code,
    ...data
  }) {
    if (_.isNil(username) || !_.isString(username)) {
      throw new GraniteError('Userrname must be valid string');
    }
    this.pk = data.pk;
    this.username = username;
    this.firstName = first_name || '';
    this.lastName = last_name || '';
    this.email = email || '';
    this.isActive = data.is_active;
    this.isEmailVerified = data.is_email_verified;
    this.isPhoneVerified = data.is_phone_verified;
    this.isSystemAdmin = data.is_business_admin;
    this.permissions = [];
    this.permissionsName = [];
    this.phone = phone.length > 0 ? {
      dialCode: phone?.split(' ')[0].replace('+', ''),
      number: phone.replace(/\s/g, '').replace(`+`, '').replace('-', ''),
      countryCode: country_code?.toLowerCase(),
      phone: phone
    } : {
      number: '',
      dialCode: '1',
      countryCode: country?.toLowerCase()
    };
    this.createDate = create_date;
    this.profileImage = profile_image;
    this.organisations = data.organisations?.map(o => ({
      name: o.organisation__name,
      pk: o.organisation__pk,
      domain: o.organisation__domain,
      logo: o.organisation__logo__document
    }));
    this.currentOrganisation = null;
    this.navigationLayout = 'side_menu_bar';
    this.twoFA = 'false';
    this.dateTimeFormat = '';
    this.dateFormat = '';
    this.timeFormat = '';
    this.timezone = '';
    this.restPreferences = {};
  }
  setAsAdmin() {
    this.isSystemAdmin = true;
  }
  removeAsAdmin() {
    this.isSystemAdmin = false;
  }
  setPermissions(data) {
    this.permissions = [...data];
  }
  setPermissionsName(data) {
    this.permissionsName = [...data];
  }
  setCurrentOrganisation(data) {
    this.currentOrganisation = {
      ...data
    };
  }
  setNavigationLayout(data) {
    this.navigationLayout = data;
  }
  setTimezone(tz) {
    this.timezone = tz;
  }
  set2FA(fa) {
    this.twoFA = fa;
  }
  setDateTimeFormat(dt) {
    this.dateTimeFormat = dt;
  }
  setDateFormat(df) {
    this.dateFormat = df;
  }
  setTimeFormat(tf) {
    this.timeFormat = tf;
  }
  setRestPreferences(pref) {
    this.restPreferences = {
      ...this.restPreferences,
      [pref.preferenceKey]: pref.value
    };
  }
}
export default User;